import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    // Function to validate the token on app load
    useEffect(() => {
        const validateToken = async () => {
            const token = localStorage.getItem('authToken');
            console.log('main token from localStorage:', token);
    
            if (!token) {
                console.log('No token found, skipping validation.');
                setIsAuthenticated(false);
                setLoading(false);
                return;
            }
    
            try {
                const response = await fetch('/api/auth/validate', {
                    headers: { 'Authorization': `Bearer ${token}` },
                });
    
                console.log('Validate API response:', response);
    
                if (response.ok) {
                    const { user } = await response.json();
                    console.log('Token validation successful:', user);
                    setUser(user);
                    setIsAuthenticated(true);
                } else {
                    console.warn('Token validation failed. Response:', await response.text());
                    setIsAuthenticated(false);
                }
            } catch (error) {
                console.error('Error during token validation:', error);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };
    
        validateToken();
    }, []);
    

    // Standard login
    const login = (token, userDetails) => {
        localStorage.setItem('authToken', token);
        localStorage.setItem('user', JSON.stringify(userDetails));
        setIsAuthenticated(true);
        setUser(userDetails);
    };

    // Google login
    const googleLogin = async (credentialToken) => {
        console.log('googleLogin called with credentialToken:', credentialToken);
    
        try {
            const response = await fetch('/api/auth/google-login', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token: credentialToken }),
            });
    
            const responseText = await response.text();
            console.log('Raw response text:', responseText);
    
            let responseData;
            try {
                responseData = JSON.parse(responseText);
                console.log('Parsed response data:', responseData);
            } catch (error) {
                console.error('Failed to parse response text as JSON:', error);
                throw new Error('Invalid JSON response from server');
            }
    
            if (responseData && responseData.tokens) {
                console.log('Google Token:', responseData.tokens.googleToken);
                console.log('JWT Token:', responseData.tokens.jwtToken);
            } else {
                console.warn('Tokens not found in the response data.');
            }
    
            console.log("Response Status:", response.status);
            console.log("Response Headers:", response.headers);
    
            if (response.ok && responseData && responseData.tokens && responseData.user) {
                const { jwtToken } = responseData.tokens;
                const { user } = responseData;
    
                if (jwtToken) {
                    localStorage.setItem('authToken', jwtToken);
                    localStorage.setItem('user', JSON.stringify(user));
                    setUser(user);
                    setIsAuthenticated(true);
                    console.log('User authenticated successfully:', user);
                } else {
                    console.warn('JWT Token not found in response.');
                }
                return responseData; 
            } else {
                console.error('Login failed:', response.statusText, responseText);
                throw new Error('Login failed');
            }
        } catch (error) {
            console.error('Error during Google login:', error);
            throw error;
        }
    };
    


    // Logout function
    const logout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
        setUser(null);
        navigate('/');
    };

    // Redirect to Auth page if not authenticated
    const redirectToAuth = () => {
        if (!isAuthenticated) {
            navigate('/');
        }
    };

    return {
        isAuthenticated,
        user,
        loading,
        login,
        googleLogin, 
        logout,
        redirectToAuth,
    };
};

export default useAuth;

